import gql from 'graphql-tag';
import {globalBannerFragments} from '@homeaway/react-global-messaging';

export const GeneralGlobalMessagesQuery = gql`
    query {
        generalGlobalMessages(experience: "STAY") {
            ...GlobalBannerGlobalMessages
        }
    }
    ${globalBannerFragments.GlobalMessages}
`;

export const GlobalMessagesTravelerStayQuery = gql`
    query globalMessagesQuery($conversationId: String!) {
        getTravelerStay(conversationId: $conversationId) {
            booking {
                globalMessages {
                    ...GlobalBannerGlobalMessages
                }
            }
        }
    }
    ${globalBannerFragments.GlobalMessages}
`;
